/* eslint-disable no-return-assign */
// eslint-disable-next-line import/no-cycle
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    trafficPerform: {
      data: [],
      categories: [],
      title: 'Traffic Performance',
      subTitle: 'Per Channel',
      color: ['#6EC5B9', '#A2DAD2', '#C3E7E2', '#D2EDE9', '#DDF2EF', '#E8F6F4'],
      total: 0,
    },
    clickPerform: {
      data: [],
      categories: [],
      title: 'Click Performance',
      subTitle: 'Per Channel',
      color: ['#4B6AAE', '#B7C3DF', '#C9D2E7', '#DBE1EF', '#E4E9F3', '#EDF0F7'],
      total: 0,
    },
    salesConversion: {
      data: [],
      categories: [],
      title: 'Sales Conversion',
      subTitle: 'Per Channel',
      color: ['#EBD06E', '#F2E1A2', '#F7ECC3', '#F9F0D2', '#FAF4DD', '#FCF7E8'],
      total: 0,
    },
    mostInventory: {
      data: [],
      categories: [],
      title: 'Most Purchase Inventory',
      subTitle: 'Per Channel',
      color: ['#e56084', '#ea809d', '#ee9ab0', '#f2b3c4', '#f7ccd8', '#fbe6eb'],
      total: 0,
    },
    mostPurchase: {
      data: [],
      title: 'Most Purchase In Time',
      subTitle: 'Per Channel',
    },
    mostIndustry: {
      data: [],
      categories: [],
      title: 'Top 6 Most Industries',
      subTitle: 'In Period',
      color: ['#c8b6fc'],
      total: 0,
    },
    mappingCategory: [
      {
        channel: 'SMS',
        text: 'SMS',
      },
      {
        channel: 'USSD',
        text: 'USSD',
      },
      {
        channel: 'Flash Message',
        text: ['Flash', 'Message'],
      },
      {
        channel: 'Digital Ads Banner',
        text: ['Digital', 'Ads Banner'],
      },
    ],
    dataNull: {
      SMS: 'SMS',
      USSD: 'USSD',
      'Flash Message': ['Flash', 'Message'],
      'Digital Ads Banner': ['Digital', 'Ads Banner'],
    },
    revenueToday: {
      total: '0',
      time: '',
    },
    revenueThisMonth: {
      total: '0',
      time: '',
    },
    revenueLastMonth: {
      total: '0',
      time: '',
    },
    spending: {
      today: '0',
      thismonth: '0',
      lastmonth: '0',
    },
    earning: {
      today: '0',
      thismonth: '0',
      lastmonth: '0',
    },
  },
  getters: {
    getTrafficPerformData: state => state.trafficPerform,
    getClickPerformData: state => state.clickPerform,
    getSalesConversionData: state => state.salesConversion,
    getMostPurchaseData: state => state.mostPurchase,
    getMostInventoryData: state => state.mostInventory,
    getInventoryData: state => state.mostInventory.data,
    getMostIndustryData: state => state.mostIndustry,
    getDataNull: state => state.dataNull,
    getRevenueToday: state => state.revenueToday,
    getRevenueThisMonth: state => state.revenueThisMonth,
    getRevenueLastMonth: state => state.revenueLastMonth,
    getSpending: state => state.spending,
    getEarning: state => state.earning,
  },
  mutations: {
    SET_TRAFFIC_PERFORM_DATA: (state, value) => (value
      ? (state.trafficPerform.data = value)
      : (state.trafficPerform.data = [])),
    SET_TRAFFIC_PERFORM_CATEGORY: (state, value) => (value
      ? (state.trafficPerform.categories = value)
      : (state.trafficPerform.categories = [])),
    SET_TRAFFIC_PERFORM_TOTAL: (state, value) => (value
      ? (state.trafficPerform.total = value)
      : (state.trafficPerform.total = 0)),
    SET_CLICK_PERFORM_DATA: (state, value) => (value
      ? (state.clickPerform.data = value)
      : (state.clickPerform.data = [])),
    SET_CLICK_PERFORM_CATEGORY: (state, value) => (value
      ? (state.clickPerform.categories = value)
      : (state.clickPerform.categories = [])),
    SET_CLICK_PERFORM_TOTAL: (state, value) => (value
      ? (state.clickPerform.total = value)
      : (state.clickPerform.total = 0)),
    SET_SALES_CONVERSION_DATA: (state, value) => (value
      ? (state.salesConversion.data = value)
      : (state.salesConversion.data = [])),
    SET_SALES_CONVERSION_CATEGORY: (state, value) => (value
      ? (state.salesConversion.categories = value)
      : (state.salesConversion.categories = [])),
    SET_SALES_CONVERSION_TOTAL: (state, value) => (value
      ? (state.salesConversion.total = value)
      : (state.salesConversion.total = 0)),
    SET_MOST_INVENTORY_DATA: (state, value) => (value
      ? (state.mostInventory.data = value)
      : (state.mostInventory.data = [])),
    SET_MOST_INVENTORY_CATEGORY: (state, value) => (value
      ? (state.mostInventory.categories = value)
      : (state.mostInventory.categories = [])),
    SET_MOST_PURCHASE_DATA: (state, value) => (value
      ? (state.mostPurchase.data = value)
      : (state.mostPurchase.data = [])),
    SET_MOST_INDUSTRY_DATA: (state, value) => (value
      ? (state.mostIndustry.data = value)
      : (state.mostIndustry.data = [])),
    SET_MOST_INDUSTRY_CATEGORY: (state, value) => (value
      ? (state.mostIndustry.categories = value)
      : (state.mostIndustry.categories = [])),
    SET_REVENUE_TODAY: (state, value) => (value ? (state.revenueToday = value) : (state.revenueToday = {})),
    SET_REVENUE_THIS_MONTH: (state, value) => (value ? (state.revenueThisMonth = value) : (state.revenueThisMonth = {})),
    SET_REVENUE_LAST_MONTH: (state, value) => (value ? (state.revenueLastMonth = value) : (state.revenueLastMonth = {})),
    SET_SPENDING: (state, value) => (value ? (state.spending = value) : (state.spending = {})),
    SET_EARNING: (state, value) => (value ? (state.earning = value) : (state.earning = {})),
  },
  actions: {
    getTrafficPerform({ commit, rootState }, payload) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      const time = payload || 'today'
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/graph/trafficPerformance/${time}`, {
            headers,
          })
          .then(response => {
            const newData = response.data.data
            // eslint-disable-next-line
            let tt = newData.category.map(item => {
              let arrItem = []
              arrItem.push(item.substr(0, item.indexOf(' ')))
              arrItem.push(item.substr(item.indexOf(' ') + 1))
              return arrItem
              // switch (item) {
              //   case 'SMS Broadcast':
              //     return 'SMS'
              //   case 'USSD 747':
              //     return 'USSD'
              //   case 'Flash Message':
              //     return ['Flash', 'Message']
              //   case 'Digital Ads Banner':
              //     return ['Digital', 'Ads Banner']
              //   default:
              //     break
              // }
            })
            let dataItem = newData.value
            let categoryItem = tt
            commit('SET_TRAFFIC_PERFORM_DATA', dataItem)
            commit('SET_TRAFFIC_PERFORM_CATEGORY', categoryItem)
            commit('SET_TRAFFIC_PERFORM_TOTAL', newData.total)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getClickPerform: ({ commit, rootState }, payload) => {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      const time = payload || 'today'
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/graph/clickPerformance/${time}`, {
            headers,
          })
          .then(response => {
            const newData = response.data.data
            // eslint-disable-next-line
            let tt = newData.category.map(item => {
              let arrItem = []
              arrItem.push(item.substr(0, item.indexOf(' ')))
              arrItem.push(item.substr(item.indexOf(' ') + 1))
              return arrItem
              // switch (item) {
              //   case 'SMS':
              //     return 'SMS'
              //   case 'USSD':
              //     return 'USSD'
              //   case 'Flash Message':
              //     return ['Flash', 'Message']
              //   case 'Digital Ads Banner':
              //     return ['Digital', 'Ads Banner']
              //   default:
              //     break
              // }
            })
            let dataItem = newData.value
            let categoryItem = tt
            commit('SET_CLICK_PERFORM_DATA', dataItem)
            commit('SET_CLICK_PERFORM_CATEGORY', categoryItem)
            commit('SET_CLICK_PERFORM_TOTAL', newData.total)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getSalesConversion: ({ commit, rootState }, payload) => {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      const time = payload || 'today'
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/graph/salesConversion/${time}`, {
            headers,
          })
          .then(response => {
            const newData = response.data.data
            // eslint-disable-next-line
            let tt = newData.category.map(item => {
              let arrItem = []
              arrItem.push(item.substr(0, item.indexOf(' ')))
              arrItem.push(item.substr(item.indexOf(' ') + 1))
              return arrItem
              // switch (item) {
              //   case 'SMS':
              //     return 'SMS'
              //   case 'USSD':
              //     return 'USSD'
              //   case 'Flash Message':
              //     return ['Flash', 'Message']
              //   case 'Digital Ads Banner':
              //     return ['Digital', 'Ads Banner']
              //   default:
              //     break
              // }
            })
            let dataItem = newData.value
            let categoryItem = tt
            commit('SET_SALES_CONVERSION_DATA', dataItem)
            commit('SET_SALES_CONVERSION_CATEGORY', categoryItem)
            commit('SET_SALES_CONVERSION_TOTAL', newData.total)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getMostInventory: ({ commit, rootState }, payload) => {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      const time = payload || 'today'
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/graph/mostPurchaseInventory/${time}`, {
            headers,
          })
          .then(response => {
            const newData = response.data.data
            // eslint-disable-next-line
            let tt = newData.category.map(item => {
              let arrItem = []
              arrItem.push(item.substr(0, item.indexOf(' ')))
              arrItem.push(item.substr(item.indexOf(' ') + 1))
              return arrItem
              // switch (item) {
              //   case 'SMS':
              //     return 'SMS'
              //   case 'USSD':
              //     return 'USSD'
              //   case 'Flash Message':
              //     return ['Flash', 'Message']
              //   case 'Digital Ads Banner':
              //     return ['Digital', 'Ads Banner']
              //   default:
              //     break
              // }
            })
            let dataItem = newData.value
            let categoryItem = tt
            commit('SET_MOST_INVENTORY_DATA', dataItem)
            commit('SET_MOST_INVENTORY_CATEGORY', categoryItem)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getMostPurchase: ({ commit, rootState }) => {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      // const time = payload || 'today'
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/graph/mostPurchaseInTime', {
            headers,
          })
          .then(response => {
            const newData = response.original
            commit('SET_MOST_PURCHASE_DATA', newData)
            resolve(newData)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getMostIndustry: ({ commit, rootState }, payload) => {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      const time = payload || 'today'
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/graph/top6MostIndustry/${time}`, {
            headers,
          })
          .then(response => {
            const newData = response.data.data
            let dataItem = newData.value
            let categoryItem = newData.category
            commit('SET_MOST_INDUSTRY_DATA', dataItem)
            commit('SET_MOST_INDUSTRY_CATEGORY', categoryItem)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getTodayRevenue: ({ commit, rootState }, payload) => {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      // const time = (payload) || 'today'
      if (payload === 2) {
        return new Promise((resolve, reject) => {
          axiosIns
            .get('/graph/totalRevenue/today', {
              headers,
            })
            .then(response => {
              const newData = response.data.data
              commit('SET_REVENUE_TODAY', newData)
              resolve(newData)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/graph/totalSpending/today', {
            headers,
          })
          .then(response => {
            const newData = response.data.data
            commit('SET_REVENUE_TODAY', newData)
            resolve(newData)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getThisMonthRevenue: ({ commit, rootState }, payload) => {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      // const time = (payload) || 'today'
      if (payload === 2) {
        return new Promise((resolve, reject) => {
          axiosIns
            .get('/graph/totalRevenue/thismonth', {
              headers,
            })
            .then(response => {
              const newData = response.data.data
              commit('SET_REVENUE_THIS_MONTH', newData)
              resolve(newData)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/graph/totalSpending/thismonth', {
            headers,
          })
          .then(response => {
            const newData = response.data.data
            commit('SET_REVENUE_THIS_MONTH', newData)
            resolve(newData)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getLastMonthRevenue: ({ commit, rootState }, payload) => {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      // const time = (payload) || 'today'
      if (payload === 2) {
        return new Promise((resolve, reject) => {
          axiosIns
            .get('/graph/totalRevenue/lastmonth', {
              headers,
            })
            .then(response => {
              const newData = response.data.data
              commit('SET_REVENUE_LAST_MONTH', newData)
              resolve(newData)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/graph/totalSpending/lastmonth', {
            headers,
          })
          .then(response => {
            const newData = response.data.data
            commit('SET_REVENUE_LAST_MONTH', newData)
            resolve(newData)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getEarningSpending: ({ commit, rootState }) => {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns
          .get('/topup/report', {
            headers,
          })
          .then(response => {
            const newData = response.data.data
            commit('SET_SPENDING', newData.spending)
            commit('SET_EARNING', newData.earning)
            resolve(newData)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
